/* CopyButton inherits all styling from IconButton.
   This file handles the confirmation state transition. */

.root {
  position: relative;
}

.iconWrap {
  display: inline-flex;
  transition: opacity var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.iconWrap[data-copied] {
  color: var(--status-success);
}
